import React from 'react'

import { PreviewQuery } from 'modules/cohort-browser/components/query/preview-query/PreviewQuery'
import {
  hasViewablePhenotypicPreviewQuery,
  mapDataAccessRequestPhenotypicQueryToPreviewQuery
} from 'modules/cohort-browser/components/query/preview-query/mapDataAccessRequestPhenotypicQueryToPreviewQuery'
import { DataAccessRequestQueryParameterSection } from 'modules/resultsV2/DataAccessRequestQueryParameterSection'
import * as styles from 'modules/resultsV2/DataAccessRequestQueryParameterSection.styles'
import {
  NO_RESTRICTION_APPLIED_MESSAGE,
  getDataAccessRequestQueryDisplayRows
} from 'modules/resultsV2/hooks/getDataAccessRequestQueryDisplayRows'
import type { DataAccessRequestQuerySource } from 'services/results/types'

export const TEST_ID_DATA_ACCESS_REQUEST_PHENOTYPIC_QUERY = 'data-access-request-phenotypic-query'
export const TEST_ID_DATA_ACCESS_REQUEST_QUERY_PREVIEW = 'data-access-request-query-preview'

interface DataAccessRequestPhenotypicQuerySectionProps {
  querySource?: DataAccessRequestQuerySource
}

export const DataAccessRequestPhenotypicQuerySection = ({
  querySource
}: DataAccessRequestPhenotypicQuerySectionProps): JSX.Element | null => {
  const { phenotypicRows, isUnrestricted } = querySource
    ? getDataAccessRequestQueryDisplayRows(querySource)
    : { phenotypicRows: [], isUnrestricted: false }

  const noRestrictionMessage = isUnrestricted ? NO_RESTRICTION_APPLIED_MESSAGE : undefined
  const phenotypic = querySource?.query?.phenotypic
  const previewQueryProps = phenotypic ? mapDataAccessRequestPhenotypicQueryToPreviewQuery(phenotypic) : null
  const hasPreviewQuery = hasViewablePhenotypicPreviewQuery(phenotypic)

  if (phenotypicRows.length === 0 && !noRestrictionMessage && !hasPreviewQuery) {
    return null
  }

  return (
    <styles.ItemRow>
      <styles.MetadataSection>
        <DataAccessRequestQueryParameterSection
          separated
          title="Phenotypic query parameters"
          rows={phenotypicRows}
          testId={TEST_ID_DATA_ACCESS_REQUEST_PHENOTYPIC_QUERY}
          emptyMessage={noRestrictionMessage}
        />
        {previewQueryProps && (
          <styles.MetadataRow>
            <styles.MetadataLabel $alignSelf="flex-start">Query</styles.MetadataLabel>
            <PreviewQuery
              mode={previewQueryProps.mode}
              query={previewQueryProps.query}
              testId={TEST_ID_DATA_ACCESS_REQUEST_QUERY_PREVIEW}
            />
          </styles.MetadataRow>
        )}
      </styles.MetadataSection>
    </styles.ItemRow>
  )
}
